// @noflow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Text } from '../components';
import withPlayer from './withPlayer';
import playerErrors from './utils/playerErrors';
import notify from '../utilities/reportingUtils';

const styles = {
  errorContainer: theme => ({
    alignItems: 'center',
    backgroundColor: theme.colors.mediumGrey,
    margin: 50,
    padding: 20,
    textAlign: 'center',
  }),
  errorText: () => ({
    fontSize: 18,
    marginBottom: 20,
  }),
  errorTextHidden: () => ({
    display: 'none',
    fontSize: 18,
    marginBottom: 20,
  }),
  errorTextMain: () => ({
    marginBottom: 30,
    fontSize: 20,
    marginTop: 20,
  }),
  errorTextAction: theme => ({
    marginBottom: 20,
    fontSize: 20,
    color: theme.colors.honey,
  }),
  button: theme => ({
    backgroundColor: theme.colors.grey,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 25,
    paddingRight: 25,
  }),
};

export class PlayerErrorMessage extends Component {
  static propTypes = {
    playerErrorCode: PropTypes.number,
    playerErrorResponseCode: PropTypes.number,
    playerErrorName: PropTypes.string,
    resetSlingErrorsObject: PropTypes.func,
    onClose: PropTypes.func,
    setPlayerError: PropTypes.func,
    togglePlayerVisibility: PropTypes.func,
    playerErrorServerResponse: PropTypes.any,
    style: PropTypes.object,
  };

  componentDidMount() {
    const {
      playerErrorCode,
      playerErrorResponseCode,
      playerErrorType,
      playerErrorName,
      // playerErrorServerResponse, // For some reason, this comes back as a UTF-8
      // string but JS uses UTF-16 and wasn't simple to use
      resetSlingErrorsObject,
    } = this.props;

    let { code, link, message } = playerErrors.default;

    switch (playerErrorCode) {
      case 2003:
        if (playerErrorResponseCode === 403 && playerErrorName === 'DRM_FAILED_LICENSE_REQUEST') {
          ({ code, message } = playerErrors[playerErrorName]);
          break;
        } else if (playerErrorResponseCode === 500) {
          ({ code, message } = playerErrors.ACCESS_DENIED);
          break;
        } else if (playerErrors[playerErrorType]) {
          ({ code, message } = playerErrors[playerErrorType]);
          break;
        } else {
          break;
        }
      case 1400:
        ({ code, link, message } = playerErrors[playerErrorName]);
        break;
      case 3006:
        ({ code, message } = playerErrors.CONNECTION_LOST);
        break;
      default:
        console.warn('playerErrorCode default case');
        break;
    }

    const error = new Error(message);
    const extraErrorInfo = {
      playerError: {
        bitmovinErrorCode: code,
        bitmovinErrorMessage: message,
        timestamp: Date.now(),
      },
      isSlingingSession: false,
    };

    notify({ error, metaData: extraErrorInfo });
  }

  closePlayer = () => {
    const { onClose, setPlayerError, togglePlayerVisibility } = this.props;
    setPlayerError(null);
    togglePlayerVisibility(false);
    if (onClose) {
      onClose();
    }
  };

  render() {
    const {
      playerErrorCode,
      playerErrorResponseCode,
      playerErrorType,
      playerErrorName,
      // playerErrorServerResponse, // For some reason, this comes back as a UTF-8
      // string but JS uses UTF-16 and wasn't simple to use
      resetSlingErrorsObject,
    } = this.props;

    if (!playerErrorCode) {
      return null;
    }

    resetSlingErrorsObject();

    let { code, link, message } = playerErrors.default;

    switch (playerErrorCode) {
      case 2003:
        if (playerErrorResponseCode === 403 && playerErrorName === 'DRM_FAILED_LICENSE_REQUEST') {
          ({ code, message } = playerErrors[playerErrorName]);
          break;
        } else if (playerErrorResponseCode === 500) {
          ({ code, message } = playerErrors.ACCESS_DENIED);
          break;
        } else if (playerErrors[playerErrorType]) {
          ({ code, message } = playerErrors[playerErrorType]);
          break;
        } else {
          break;
        }
      case 1400:
        ({ code, link, message } = playerErrors[playerErrorName]);
        break;
      case 3006:
        ({ code, message } = playerErrors.CONNECTION_LOST);
        break;
      default:
        console.warn('playerErrorCode default case');
        break;
    }

    return (
      <Box style={styles.errorContainer}>
        <Text style={styles.errorText} testID="error-message">
          {message}
        </Text>
        <Text style={styles.errorTextHidden} testID="error-type">
          Error Type:
          {playerErrorType}
        </Text>
        {link && <Text style={styles.errorText}>{link}</Text>}
        <Text style={styles.errorText} testID="error-code">
          Number:&nbsp;
          {code}
        </Text>
        <Button
          onClick={this.closePlayer}
          onPress={this.closePlayer}
          style={styles.button}
          testID="close-button"
        >
          <Text testID="close-button-label">Close Player</Text>
        </Button>
      </Box>
    );
  }
}

export default withPlayer(PlayerErrorMessage);
